export default {
    // 查询岗位信息
    queryPortStation(params, response) {
        window.vue.$apiAxios.postRequestBody('/portStationManagerController/queryPortStation', params, response);
    },
    // 添加岗位信息
    addPortStation(params, response) {
        window.vue.$apiAxios.postRequestBody('/portStationManagerController/addPortStation', params, response);
    },
    // 修改岗位信息
    updatePortStation(params, response) {
        window.vue.$apiAxios.postRequestBody('/portStationManagerController/updatePortStation', params, response);
    },
    // 修改岗位信息
    deletePortStation(params, response) {
        window.vue.$apiAxios.postRequestBody('/portStationManagerController/deletePortStation', params, response);
    },

    // 上下移
    moveUpOrDown(params, responseType, response) {
        window.vue.$apiAxios.postRequestBody('/portStationManagerController/moveUpOrDown', params, responseType, response);
    },

    // 查询上一个或者下一个节点
    queryPerviousOrLatter(params, responseType, response) {
        window.vue.$apiAxios.postRequestBody('/portStationManagerController/queryPerviousOrLatter', params, responseType, response);
    },

    // 置顶
    moveToTop(params, responseType, response) {
        window.vue.$apiAxios.postRequestBody('/portStationManagerController/moveToTop', params, responseType, response);
    },

    // 取消置顶
    removeFromTop(params, responseType, response) {
        window.vue.$apiAxios.postRequestBody('/portStationManagerController/removeFromTop', params, responseType, response);
    },

    // 查询字典表中的职级信息
    getDictValuesByTag(params, response) {
        return window.vue.$apiAxios.get('/setting/dictController/getDictValuesByTag', params, response);
    }
};
